package com.parmartechnologies.core.extension

import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

@Serializable
abstract class BaseDataClass {
    @SerialName("_id")
    open var _id: String = UniqueueID()
    @SerialName("id")
    open var id: String = UniqueueID()

    @OptIn(ExperimentalTime::class)
    @SerialName("created_at") var createdAt: String = Clock.System.now().toLocalDateTime(TimeZone.UTC).toString()

    @OptIn(ExperimentalTime::class)
    @SerialName("updated_at") val updatedAt: String = Clock.System.now().toLocalDateTime(TimeZone.UTC).toString()

    @SerialName("__v") var _v: Int = 0
}